import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import useRouteChangeConfirm from 'use/route-change-confirm'
import { useHistory } from 'react-router'
import { PATH_TICKET_SUPPORT } from 'routes/paths'

// Model
import Ecwt from 'models/Ecwt'

// Components
import Text from 'ui/Text'
import PdfViewer from 'ui/PdfViewer'
import EcwtFileDownload from './EcwtFileDownload'
import EcwtAcknowledge from './EcwtAcknowledge'
import Box from 'ui/Box'
import dialog from 'services/dialog'
import PopupAcknowledge from './PopupAcknowledge'

export const EcwtView = ({ ecwt, onRefresh }) => {
  const history = useHistory()

  const onRaiseTicket = useCallback(() => {
    history.push({
      pathname: PATH_TICKET_SUPPORT,
      search: `?ecwtId=${ecwt.id}`,
    })
  }, [ecwt.id, history])

  const onResolveClick = useCallback(
    ({ next, path }) => {
      if (path === PATH_TICKET_SUPPORT) {
        next()
      }

      dialog.create(PopupAcknowledge, {
        ecwt,
        onRaiseTicket,
        next,
      })

      return false
    },
    [ecwt, onRaiseTicket]
  )

  const preventChangeRoute = useMemo(() => {
    if (ecwt.isVoid) {
      return false
    }

    return !ecwt.isAcknowledge
  }, [ecwt.isAcknowledge, ecwt.isVoid])

  useRouteChangeConfirm(preventChangeRoute, onResolveClick)

  return (
    <div>
      <Box style={{ padding: '20px 25px' }}>
        <div style={{ borderBottom: '1px dashed rgb(189, 178, 178)' }}>
          <Text size={18} bold color="#000000">
            BIR Form 2307
          </Text>
          <div>
            <PdfViewer data={ecwt.embedPdf} />
          </div>
        </div>

        <EcwtFileDownload ecwt={ecwt} />
      </Box>
      {ecwt.isVoid ? null : (
        <EcwtAcknowledge
          ecwt={ecwt}
          onRefresh={onRefresh}
          onRaiseTicket={onRaiseTicket}
        />
      )}
    </div>
  )
}

EcwtView.propTypes = {
  ecwt: PropTypes.instanceOf(Ecwt),
  onRefresh: PropTypes.func,
}

EcwtView.defaultProps = {
  ecwt: new Ecwt(),
  onRefresh: () => {},
}

export default EcwtView
